/**
 * 知识库预设分类与标签，供创建/编辑时选择
 */

/** 预设分类（文档类型） */
export const PRESET_CATEGORIES = [
  { value: '实验操作', label: '实验操作' },
  { value: '仪器使用', label: '仪器使用' },
  { value: '安全规范', label: '安全规范' },
  { value: '试剂管理', label: '试剂管理' },
  { value: '耗材管理', label: '耗材管理' },
  { value: '文献检索', label: '文献检索' },
  { value: '数据处理', label: '数据处理' },
  { value: '其他', label: '其他' },
];

/** 预设标签（可多选，点击即添加） */
export const PRESET_TAGS = [
  'SOP',
  '入门',
  '进阶',
  '安全',
  '常用',
  '必读',
  '更新',
  '操作步骤',
  '注意事项',
  '故障排查',
];
